import React from 'react';

const FitQueenTerms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Terms of Use</h1>
      <p className="text-center text-gray-600 mb-4">FitQueen: Home Workout Women · Last updated: March 18, 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">

        <h2 className="text-xl font-semibold mt-8">1. Acceptance of Terms</h2>
        <p>
          By downloading, installing, or using FitQueen: Home Workout Women ("the App"), you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use the App.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Description of Service</h2>
        <p>
          FitQueen is a fitness application that provides AI-powered workout tracking, structured training programs, and health-related tools. The App uses your device's front-facing camera to analyze body movements in real time for exercise tracking purposes. No video or images are recorded, stored, or transmitted — all processing occurs locally on your device.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Eligibility</h2>
        <p>
          You must be at least 13 years of age to use the App. If you are under 18, you must have permission from a parent or legal guardian. By using the App, you represent that you meet these requirements.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Account Registration</h2>
        <p>
          You may create an account using Apple Sign In or email/password. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Subscriptions & Payments</h2>
        <p>
          FitQueen offers auto-renewable subscription plans that unlock premium features. By subscribing, you agree to the following:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Payment will be charged to your Apple ID account at the confirmation of purchase.</li>
          <li>Your subscription automatically renews unless auto-renew is turned off at least 24 hours before the end of the current billing period.</li>
          <li>Your account will be charged for renewal within 24 hours prior to the end of the current period at the rate of the selected plan.</li>
          <li>You can manage and cancel your subscriptions by going to your Account Settings in the App Store after purchase.</li>
          <li>Any unused portion of a free trial period, if offered, will be forfeited when you purchase a subscription.</li>
          <li>Prices are in US dollars and may vary in other countries. Actual charges may be converted to your local currency by your payment provider.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">6. Free Trial</h2>
        <p>
          If a free trial is offered, it will automatically convert to a paid subscription at the end of the trial period unless you cancel at least 24 hours before the trial ends. You can cancel the free trial at any time through your App Store Account Settings.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Health Disclaimer</h2>
        <p>
          FitQueen is designed for general fitness purposes only and is not a substitute for professional medical advice, diagnosis, or treatment. Always consult a qualified healthcare provider before starting any exercise program, especially if you have pre-existing health conditions, injuries, or are pregnant. You use the App and perform exercises entirely at your own risk.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. AI Camera Tracking</h2>
        <p>
          The App uses Apple's Vision Framework to detect body poses through your device's camera. This feature:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Processes all data locally on your device in real time.</li>
          <li>Does not record, save, stream, or transmit any video, photos, or images.</li>
          <li>Does not use facial recognition or identify individuals.</li>
          <li>Can be used only when you explicitly start a workout session.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">9. User Conduct</h2>
        <p>
          You agree not to: (a) reverse-engineer, decompile, or disassemble the App; (b) use the App for any unlawful purpose; (c) attempt to gain unauthorized access to any part of the App or its systems; (d) share, resell, or redistribute your account or subscription access.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. Intellectual Property</h2>
        <p>
          All content, features, designs, trademarks, and functionality of the App are the exclusive property of N1 Inovasyon and are protected by international copyright and intellectual property laws. You may not copy, reproduce, or distribute any part of the App without prior written consent.
        </p>

        <h2 className="text-xl font-semibold mt-8">11. Account Deletion</h2>
        <p>
          You may delete your account at any time through the App's Settings. Upon deletion, all your personal data stored on our servers (including workout history, profile information, and weight records) will be permanently removed. Active subscriptions must be cancelled separately through the App Store.
        </p>

        <h2 className="text-xl font-semibold mt-8">12. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, N1 Inovasyon shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to personal injury, loss of data, or loss of profits arising from your use of the App.
        </p>

        <h2 className="text-xl font-semibold mt-8">13. Modifications to Terms</h2>
        <p>
          We reserve the right to modify these Terms of Use at any time. Changes will be effective upon posting the updated terms within the App or on our website. Your continued use of the App after changes constitutes acceptance of the modified terms.
        </p>

        <h2 className="text-xl font-semibold mt-8">14. Termination</h2>
        <p>
          We may suspend or terminate your access to the App at any time, without prior notice, for conduct that we determine violates these Terms or is harmful to other users, us, or third parties.
        </p>

        <h2 className="text-xl font-semibold mt-8">15. Governing Law</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the laws of the Republic of Turkey, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-xl font-semibold mt-8">16. Contact Us</h2>
        <p>
          If you have questions about these Terms, please contact us at:
        </p>
        <p className="ml-4">
          E-mail: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600 hover:text-blue-800">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            By using this application, you confirm that you have read and accepted the above terms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FitQueenTerms;
